import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import DisciplinesList from '../components/DisciplinesList'

export default function ManageDisciplines() {

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);
  
  return (
    <div className='eczmembers'>
      <div className="memberTitleContainer">
        <h1 className="newMemberTitle">Disciplines</h1>
        <Link to="/new-discipline"><button className="memberAddButton">Add New</button></Link>
      </div>
        <DisciplinesList />
    </div>
  )
}
